<template>
  <div class="max-w-6xl mx-auto p-6">
    <!-- Back Button -->
    <div class="mb-6">
      <button 
        @click="goBack"
        class="inline-flex items-center gap-2 text-indigo-600 hover:text-indigo-800 font-medium transition-colors"
      >
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
        </svg>
        Tillbaka till evenemang
      </button>
    </div>

    <div class="grid md:grid-cols-3 gap-6">
      <!-- Step Content -->
      <div class="md:col-span-2">
        <div class="mb-6">
          <div class="flex items-center justify-between">
            <div
              v-for="n in 3"
              :key="n"
              class="flex items-center gap-2"
            >
              <div :class="stepCircle(n)">{{ n }}</div>
              <span :class="stepText(n)">
                {{ stepLabels[n - 1] }}
              </span>
              <div v-if="n < 3" class="w-8 border-t border-gray-300"></div>
            </div>
          </div>
        </div>

        <component
        v-if="event"
          :is="currentComponent"
          :event="event"
          :buyer="buyer"
          @next="step++"
          @back="step--"
          @update-buyer="updateBuyer"
        />
      </div>

      <!-- Order Summary -->
      <div class="bg-white shadow rounded-lg p-4">
        <h3 class="text-lg font-semibold mb-2">Sammanfattning</h3>
        <div v-for="ticket in selectedTickets" :key="ticket.name" class="text-sm mb-1">
          {{ ticket.name }} x {{ ticket.selected }} - {{ ticket.price * ticket.selected }} kr
        </div>
        <div class="mt-4 font-bold">
          Totalt: {{ totalPrice }} kr
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import TicketStep1 from '@/components/TicketStep1.vue';
import TicketStep2 from '@/components/TicketStep2.vue';
import TicketStep3 from '@/components/TicketStep3.vue';

export default {
  data() {
    return {
      step: 1,
      event: null,
      buyer: { name: '', email: '', phone: '' },
      stepLabels: ['Biljetter', 'Uppgifter', 'Betalning']
    };
  },
  computed: {
    currentComponent() {
      return {
        1: TicketStep1,
        2: TicketStep2,
        3: TicketStep3
      }[this.step];
    },
    selectedTickets() {
      if (!this.event) return [];
      return this.event.ticketTypes.filter(t => t.selected > 0);
    },
    totalPrice() {
      return this.selectedTickets.reduce(
        (sum, t) => sum + t.selected * t.price,
        0
      );
    }
  },
  methods: {
    stepCircle(n) {
      return `w-8 h-8 rounded-full flex items-center justify-center font-bold ${
        this.step >= n ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-500'
      }`;
    },
    stepText(n) {
      return `text-sm ${this.step === n ? 'text-blue-600' : 'text-gray-500'}`;
    },
    updateBuyer(buyerData) {
      this.buyer = { ...this.buyer, ...buyerData };
    },
    goBack() {
      this.$router.push(`/events/${this.$route.params.id}`);
    }
  },
  async created() {
    const res = await axios.get(`/api/events/${this.$route.params.id}`);
    this.event = res.data;

    // Add selected: 0 to each ticket
    this.event.ticketTypes = this.event.ticketTypes.map(t => ({
      ...t,
      selected: 0
    }));
  }
};
</script>

<style scoped>
/* Optional styling */
</style>